export default "__VITE_PUBLIC_ASSET__2000da27__"